const ProblemSection = () => {
  const problems: Array<{
    icon: string;
    title: string;
    desc: string;
  }> = [
    {
      icon: "📋",
      title: "Fragmented Deal Information",
      desc: "broker chaos + lender frustration with incomplete packages.",
    },
    {
      icon: "🔍",
      title: "No Structured Submission Process",
      desc: " broker guesswork + lenders receiving the wrong deals.",
    },
    {
      icon: "📂",
      title: "Document Gaps Stall Every Deal",
      desc: `broker chasing + lenders stuck waiting before underwriting.`,
    },
    {
      icon: "📊",
      title: "No Shared Visibility Into Deal Status",
      desc: "brokers in the dark on submissions + lenders losing track of pipeline",
    },
  ];

  return (
    <section className="problem bg-[#D6D7D721] py-24 px-5" id="problem">
      <div className="text-center max-w-4xl mx-auto">
        <div className="section-label text-xs font-bold uppercase tracking-wider text-blue-500 mb-3">
          The Challenge
        </div>
        <h2 className="section-title text-3xl sm:text-4xl lg:text-[2.75rem] font-black leading-tight mb-4">
          Brokering loans shouldn't feel like
          <br />
          managing chaos
        </h2>
        <p className="section-sub text-xl text-slate-600 max-w-xl mx-auto leading-relaxed">
          Most brokers are juggling spreadsheets, emails, and scattered
          documents — with no single system to see where every deal stands. That
          costs time, deals, and credibility.
        </p>
      </div>
      <div className="problem-grid mt-16 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 gap-5 mb-[1rem] text-left">
        {problems.map((problem, index) => (
          <div
            key={index}
            className="problem-card bg-white border border-slate-200 rounded-xl p-7"
          >
            <div className="text-2xl mb-3.5">{problem.icon}</div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">
              {problem.title}
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              {problem.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProblemSection;
